import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import * as Highcharts from 'highcharts';
import { HighchartsChartModule } from 'highcharts-angular';
import { numberValueConversion } from '@mds/common';
import { EPD_CARBON_FOOTPRINT_CHART_OPTIONS } from '@pages/dashboards/epd-v2/utils/chart-options';
import { EmptyChartComponent } from '@pages/dashboards/shared/empty-chart/empty-chart.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ReactiveFormsModule } from '@angular/forms';
import { cloneDeep } from 'lodash';

@Component({
  selector: 'app-epd-carbon-footprint',
  standalone: true,
  imports: [CommonModule, HighchartsChartModule, EmptyChartComponent, MatTooltipModule, ReactiveFormsModule],
  templateUrl: './epd-carbon-footprint.component.html',
  styleUrls: ['./epd-carbon-footprint.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EpdCarbonFootprintComponent implements OnInit {
  @Input() data: any;
  chartCallback: any;
  highcharts = Highcharts;
  chartOptions: Highcharts.Options;
  emptyChart = { title: 'No Data', description: 'No data available' };
  private cdr = inject(ChangeDetectorRef);
  constructor() {
    this.chartCallback = (chart: Highcharts.Chart) => {
      setTimeout(() => {
        chart.reflow();
      }, 0);
    };
  }
  ngOnInit(): void {
    const data = this.data.stages;
    data.forEach((li: any) => {
      li.y = li.value >= 0 ? li.value : li.value * -1;
      li.impact = numberValueConversion(li.value);
      li.label = li.name;
    });
    const total = data.reduce((sum, { y }) => sum + y, 0);
    data.forEach((li) => {
      if (li.y) li.y = Math.max((li.y / total) * 100, 0.5);
    });
    this.chartOptions = cloneDeep(EPD_CARBON_FOOTPRINT_CHART_OPTIONS(total, data));
    this.cdr.markForCheck();
  }
}
